import script from "./CarouselFullScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselFullScreen.vue?vue&type=script&setup=true&lang=js"

import "./CarouselFullScreen.vue?vue&type=style&index=0&id=e8118a1a&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8118a1a"]])

export default __exports__